module.exports = __webpack_public_path__ + "static/media/snap_old.b4c66f87.png";